export const PieChart = (props) => {
  const { size = 20, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 20 20'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.25'
          d='M17.152 11.85a6.273 6.273 0 01-1.165 2.808c-.3.403-.898.431-1.253.077l-2.409-2.409a.833.833 0 01.59-1.423h3.405c.505 0 .907.448.832.947zM17.152 7.248a6.324 6.324 0 00-5.302-5.302.835.835 0 00-.947.83v4.585c0 .46.373.833.833.833h4.584a.835.835 0 00.832-.946zM1.998 13.074a6.327 6.327 0 015.26-7.519c.496-.073.936.33.936.83v5.075c0 .221.088.433.245.59l3.586 3.586c.356.356.325.956-.08 1.255-1.352 1-3.117 1.472-4.993 1.115-2.474-.47-4.473-2.46-4.954-4.932z'
        ></path>
      </svg>
    </span>
  );
};
